module.exports = __webpack_public_path__ + "static/media/piyush.7945a9bb.png";